import React, { useState, useEffect } from "react";
import { Row, Col, Card, Form, Collapse, Input, Skeleton } from "antd";
import { CAN, USA, HKG, IND, MEX, PAN, PHL, POL, TTO, COL, EGY, AUS } from "./country";
import {
  SelectBox,
  DatePicker,
  InputBox,
  TextArea,
  isBrowser,
} from "../../../shared/custom-ant-d";
import { DatePicker as DatePickerBV } from "antd";
import moment from "moment";

const { Panel } = Collapse;

const JobInfo = (props) => {
  const [getWorkedAtiQorInd, setWorkedAtiQorInd] = useState(null);
  const [getScheduleRestrictionsInd, setScheduleRestrictionsInd] =
    useState(null);
  const [daysOfMonth, setDaysOfMonth] = useState([]);
  const months = [
    "",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  const onMonthChanged = (value) => {
    const days = [];
    if (value === "02") {
      for (let x = 0; x < 29; x++) {
        days.push(`${x + 1}`.length == 1 ? `0${x + 1}` : `${x + 1}`);
      }
    } else if (["04", "06", "09", "11"].includes(value)) {
      for (let x = 0; x < 30; x++) {
        days.push(`${x + 1}`.length == 1 ? `0${x + 1}` : `${x + 1}`);
      }
    } else if (["01", "03", "05", "07", "08", "10", "12"].includes(value)) {
      for (let x = 0; x < 31; x++) {
        days.push(`${x + 1}`.length == 1 ? `0${x + 1}` : `${x + 1}`);
      }
    }
    setDaysOfMonth(days);
  };

  useEffect(() => {
    if (props.jobDetails) {
      setWorkedAtiQorInd(props.jobDetails.workedAtiQorInd);
      setScheduleRestrictionsInd(props.jobDetails.scheduleRestrictionsInd);

      let monthOfBirth =
        props.jobDetails.monthOfBirth === undefined ||
        props.jobDetails.monthOfBirth === null
          ? ""
          : props.jobDetails.monthOfBirth > 0 &&
            props.jobDetails.monthOfBirth < 10
          ? "0" + props.jobDetails.monthOfBirth
          : props.jobDetails.monthOfBirth;
      onMonthChanged(monthOfBirth);
    }
  }, [props.jobDetails]);

  return (
    <>
      <Row justify="center" style={{ fontSize: "12px" }} id="JobInfo">
        <Col sm={23} xs={24}>
          <Card
            size="large"
            title="Job Specific Information"
            className="iqor-header"
          >
            {props.isLoading ? (
              <Skeleton active />
            ) : (
              <>
                <section id="jobs-info">
                  <Row align="bottom">
                    <Col md={{ span: 11 }} xs={24}>
                      <Form.Item
                        name="is18OrOlder"
                        label={
                          <b>
                            VOYA requires you to be at least 18 years of age to be eligible for employment. Indicate you are 18 years of age or older?
                          </b>
                        }
                        hasFeedback
                        rules={[
                          {
                            required: true,
                            whitespace: true,
                            message:
                              "VOYA requires you to be at least 18 years of age to be eligible for employment. Indicate you are 18 years of age or older? is required",
                          },
                        ]}
                        initialValue={""}
                      >
                        <SelectBox
                          data={[
                            { value: "true", label: "Yes" },
                            { value: "false", label: "No" },
                          ]}
                          label={""}
                          onChange={(value) => {
                            props.resetFieldValues({ is18OrOlder: value });
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col md={{ span: 11, offset: 1 }} xs={24}>
                      <Form.Item
                        name="workedAtiQorInd"
                        label={
                          <b>
                            Have you previously worked at VOYA?
                          </b>
                        }
                        hasFeedback
                        rules={[
                          {
                            required: true,
                            whitespace: true,
                            message:
                              "Have you previously worked at VOYA? is required.",
                          },
                        ]}
                        initialValue={""}
                      >
                        <SelectBox
                          data={[
                            { value: "true", label: "Yes" },
                            { value: "false", label: "No" },
                          ]}
                          label={""}
                          onChange={(value) => {
                            props.resetFieldValues({ workedAtiQorInd: value });
                            const newVal =
                              value === ""
                                ? null
                                : value === "true"
                                ? true
                                : false;
                            setWorkedAtiQorInd(newVal);
                            if (newVal === false || newVal === null) {
                              props.resetFieldValues({
                                lastDayWorked: null,
                                previousiQorLocation: null,
                              });
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </section>
                {getWorkedAtiQorInd ? (
                  <Row>
                    <Col md={{ span: 11 }} xs={24}>
                      <Form.Item
                        name="lastDayWorked"
                        label={<b>If yes, please provide last day worked?</b>}
                        hasFeedback
                        initialValue={null}
                      >
                        {isBrowser ? (
                          <DatePickerBV
                            label={""}
                            value={props.form.getFieldValue("lastDayWorked")}
                            format={"MM/DD/YYYY"}
                            style={{ width: "100%" }}
                            onChange={(value) => {
                              props.form.setFieldsValue({
                                lastDayWorked: value,
                              });
                            }}
                            disabledDate={(current) => {
                              return current && current > moment().endOf("day");
                            }}
                          />
                        ) : (
                          <DatePicker
                            label={""}
                            maxDate={new Date()}
                            value={props.form.getFieldValue("lastDayWorked")}
                            onChange={(value) => {
                              props.form.setFieldsValue({
                                lastDayWorked: value,
                              });
                            }}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col md={{ span: 11, offset: 1 }} xs={24}>
                      <Form.Item
                        name="previousiQorLocation"
                        label={
                          <b>If yes, what VOYA location did you work at?</b>
                        }
                        hasFeedback
                        initialValue={null}
                      >
                        {isBrowser ? <Input /> : <InputBox />}
                      </Form.Item>
                    </Col>
                  </Row>
                ) : (
                  <></>
                )}
                <Row>
                  <Col md={{ span: 11 }} xs={24}>
                    <Form.Item
                      name="isSponsorshipRequired"
                      label={
                        <b>
                          Will you now or in the future require VOYA to commence ("sponsor") an immigration case in order to employ you?
                        </b>
                      }
                      hasFeedback
                      rules={[
                        {
                          required: true,
                          whitespace: true,
                          message: "This is a required field.",
                        },
                      ]}
                      initialValue={""}
                    >
                      <SelectBox
                        data={[
                          { value: "true", label: "Yes" },
                          { value: "false", label: "No" },
                        ]}
                        label={""}
                        onChange={(value) => {
                          props.resetFieldValues({
                            isSponsorshipRequired: value,
                          });
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={{ span: 11, offset: 1 }} xs={24}>
                    <Form.Item
                      name="highestLevelOfEducationID"
                      label={<b>What is your highest level of education?</b>}
                      hasFeedback
                      rules={[
                        {
                          required: true,
                          whitespace: true,
                          message:
                            "What is your highest level of education? is required.",
                        },
                      ]}
                      initialValue={null}
                    >
                      <SelectBox
                        data={
                          props.levelOfEduc &&
                          props.levelOfEduc.map((item, i) => {
                            return {
                              value: item.codeValueID.toString(),
                              label: item.codeValueDescription,
                            };
                          })
                        }
                        label={""}
                        onChange={(value) => {
                          props.resetFieldValues({
                            highestLevelOfEducationID: value,
                          });
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                {!props.workSchedShow ? (
                  <></>
                ) : (
                  <Collapse defaultActiveKey={1} expandIconPosition={"right"}>
                    <Panel id="work-sched" header="Work Schedule" key="1">
                      <Row justify="space-between">
                        <Col md={{ span: 11 }} xs={24}>
                          <Form.Item
                            name="availableWeekendInd"
                            label={
                              <b>
                                Are you available to work one or more weekend
                                days?
                              </b>
                            }
                            hasFeedback
                            rules={[
                              {
                                required: true,
                                whitespace: true,
                                message: "This field is required.",
                              },
                            ]}
                            initialValue={""}
                          >
                            <SelectBox
                              data={[
                                { value: "true", label: "Yes" },
                                { value: "false", label: "No" },
                              ]}
                              label={""}
                              onChange={(value) => {
                                props.resetFieldValues({
                                  availableWeekendInd: value,
                                });
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col md={{ span: 11 }} xs={24}>
                          <Form.Item
                            name="availableEveningInd"
                            label={<b>Are you available to work evenings?</b>}
                            hasFeedback
                            rules={[
                              {
                                required: true,
                                whitespace: true,
                                message: "This field is required.",
                              },
                            ]}
                            initialValue={""}
                          >
                            <SelectBox
                              data={[
                                { value: "true", label: "Yes" },
                                { value: "false", label: "No" },
                              ]}
                              label={""}
                              onChange={(value) => {
                                props.resetFieldValues({
                                  availableEveningInd: value,
                                });
                              }}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <section id="section-4">
                        <Row justify="space-between">
                          <Col md={{ span: 11 }} xs={24}>
                            <Form.Item
                              name="scheduleRestrictionsInd"
                              label={
                                <b>Do you have any schedule restrictions?</b>
                              }
                              hasFeedback
                              rules={[
                                {
                                  required: true,
                                  whitespace: true,
                                  message: "This field is required.",
                                },
                              ]}
                              initialValue={""}
                            >
                              <SelectBox
                                data={[
                                  { value: "true", label: "Yes" },
                                  { value: "false", label: "No" },
                                ]}
                                label={""}
                                onChange={(value) => {
                                  props.resetFieldValues({
                                    scheduleRestrictionsInd: value,
                                  });
                                  const newVal =
                                    value === ""
                                      ? null
                                      : value === "true"
                                      ? true
                                      : false;
                                  setScheduleRestrictionsInd(newVal);
                                  if (newVal === false || newVal === null) {
                                    props.resetFieldValues({
                                      scheduleRestrictionsDetail: null,
                                    });
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col>
                          {getScheduleRestrictionsInd ? (
                            <Col md={{ span: 11 }} xs={24}>
                              <Form.Item
                                name="scheduleRestrictionsDetail"
                                label={<b>If yes, please provide details?</b>}
                                hasFeedback
                                rules={[
                                  {
                                    max: 800,
                                    message:
                                      "This field cannot be longer than 800 characters",
                                  },
                                ]}
                                initialValue={null}
                              >
                                <TextArea />
                              </Form.Item>
                            </Col>
                          ) : (
                            <></>
                          )}
                        </Row>
                      </section>
                    </Panel>
                  </Collapse>
                )}
                <br />
                {(props.jobDetails &&
                  props.jobDetails.jobPostingCountryCode === "USA") ||
                props.jobDetails.postingCountryCode === "USA" ? (
                  <USA
                    {...props}
                    {...{ months, onMonthChanged, daysOfMonth }}
                  />
                ) : (
                  <></>
                )}
                {(props.jobDetails &&
                  props.jobDetails.jobPostingCountryCode === "CAN") ||
                props.jobDetails.postingCountryCode === "CAN" ? (
                  <CAN
                    {...props}
                    {...{ months, onMonthChanged, daysOfMonth }}
                  />
                ) : (
                  <></>
                )}
                {(props.jobDetails &&
                  props.jobDetails.jobPostingCountryCode === "HKG") ||
                props.jobDetails.postingCountryCode === "HKG" ? (
                  <HKG
                    {...props}
                    {...{ months, onMonthChanged, daysOfMonth }}
                  />
                ) : (
                  <></>
                )}
                {(props.jobDetails &&
                  props.jobDetails.jobPostingCountryCode === "IND") ||
                props.jobDetails.postingCountryCode === "IND" ? (
                  <IND {...props} />
                ) : (
                  <></>
                )}
                {(props.jobDetails &&
                  props.jobDetails.jobPostingCountryCode === "MEX") ||
                props.jobDetails.postingCountryCode === "MEX" ? (
                  <MEX {...props} />
                ) : (
                  <></>
                )}
                {(props.jobDetails &&
                  props.jobDetails.jobPostingCountryCode === "PHL") ||
                props.jobDetails.postingCountryCode === "PHL" ? (
                  <PHL
                    {...props}
                    {...{ months, onMonthChanged, daysOfMonth }}
                  />
                ) : (
                  <></>
                )}
                {(props.jobDetails &&
                  props.jobDetails.jobPostingCountryCode === "PAN") ||
                props.jobDetails.postingCountryCode === "PAN" ? (
                  <PAN {...props} />
                ) : (
                  <></>
                )}
                {(props.jobDetails &&
                  props.jobDetails.jobPostingCountryCode === "POL") ||
                props.jobDetails.postingCountryCode === "POL" ? (
                  <POL {...props} />
                ) : (
                  <></>
                )}
                {(props.jobDetails &&
                  props.jobDetails.jobPostingCountryCode === "TTO") ||
                props.jobDetails.postingCountryCode === "TTO" ? (
                  <TTO
                    {...props}
                    {...{ months, onMonthChanged, daysOfMonth }}
                  />
                ) : (
                  <></>
                )}
                {(props.jobDetails &&
                  props.jobDetails.jobPostingCountryCode === "COL") ||
                props.jobDetails.postingCountryCode === "COL" ? (
                  <COL
                    {...props}
                    {...{ months, onMonthChanged, daysOfMonth }}
                  />
                ) : (
                  <></>
                )}
                {(props.jobDetails &&
                  props.jobDetails.jobPostingCountryCode === "EGY") ||
                  props.jobDetails.postingCountryCode === "EGY" ? (
                  <EGY
                    {...props}
                    {...{ months, onMonthChanged, daysOfMonth }}
                  />
                ) : (
                  <></>
                )}
                {(props.jobDetails &&
                  props.jobDetails.jobPostingCountryCode === "AUS") ||
                  props.jobDetails.postingCountryCode === "AUS" ? (
                  <AUS
                    {...props}
                    {...{ months, onMonthChanged, daysOfMonth }}
                  />
                ) : (
                  <></>
                )}
              </>
            )}
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default JobInfo;
